import React from 'react'

import { Slider } from '@makyoapp/makyo-ui'

import { useUpdateCompSettingValue } from '@/hooks/useUpdateCompSettings'
import { BuilderComponentSetting } from '@/shared/builder'

const SliderSelectFieldSetting = ({
  settingId,
  value,
  id,
  sliderSelectSettings,
}: {
  id: string
  settingId: string
  value: any
  sliderSelectSettings: BuilderComponentSetting['sliderSelectSettings']
}) => {
  const { options = [] } = sliderSelectSettings ?? {}
  const valueIdx = options.indexOf(value as number)
  const realValue = valueIdx === -1 ? 0 : valueIdx

  const updateValue = useUpdateCompSettingValue(id)

  return (
    <div className='w-full relative'>
      <Slider
        id={settingId}
        min={0}
        max={options.length - 1}
        step={1}
        values={[realValue]}
        renderLabel={(i) => options[i]}
        renderTrackLabel={(i) => options[i]}
        showMark
        onChange={async (i) => {
          const nextValue = options[i[0]]
          if (typeof nextValue === 'number') {
            await updateValue(nextValue)
          }
        }}
      />
    </div>
  )
}

export default SliderSelectFieldSetting
